<div class="navbar">
  <div class="content">
    <div class="left" routerLink="">
      <img
        width="27"
        height="25"
        src="../../../../assets/images/yunlogin/logo.png"
        alt="universalbus"
      />
      <span>环球巴士</span>
    </div>
    <div class="right">
      <div class="box" routerLink="/chatgpt-course">
        <div class="link">AIGC</div>
        <div [ngClass]="{ active: url === '/chatgpt-course' }"></div>
      </div>
      <div class="box" (click)="temp()">
        <div class="link">影音</div>
        <div></div>
      </div>
      <div class="box">
        <div class="link">效率</div>
        <div></div>
      </div>
      <div class="box">
        <div class="link">苹果</div>
        <div></div>
      </div>
    </div>
  </div>
</div>
<div class="header">
  <div class="left">
    <div class="title">ChatGPT Plus 随心用 不封号！</div>
    <div class="subtitle">无需海外网络环境！</div>
    <div class="pc">
      <div class="content">
        <div class="step"><span>Mac系统版本</span></div>
        <div class="step"><span>Windows版本</span></div>
        <div class="step">均已上线</div>
      </div>
      <button (click)="download()">立即下载</button>
    </div>
  </div>
  <div class="right">
    <img
      width="647"
      height="335"
      src="../../../../assets/images/yunlogin/head-icon.webp"
      alt="chatgpt"
    />
  </div>
</div>
<router-outlet></router-outlet>
<!-- <app-page-footer></app-page-footer> -->
